var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoriesText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.44444,
    y: -4.44444,
    width: 48.8889,
    height: 48.8889
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.22px)",
      clipPath: "url(#bgblur_0_5445_229154_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 4.44444,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48779 26.6667L14.1058 14.1406H15.3038V16.1632H14.809L11.1284 26.6667H9.48779ZM11.5798 23.0816L12.0659 21.7535H17.7256L18.2118 23.0816H11.5798ZM18.6284 26.6667L14.9479 16.1632V14.1406H15.651L20.269 26.6667H18.6284Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7569 26.8316C24.1666 26.8316 23.6342 26.7188 23.1597 26.4931C22.6909 26.2674 22.3177 25.9462 22.0399 25.5295C21.7679 25.1128 21.6319 24.6209 21.6319 24.0538V24.0365C21.6319 23.4809 21.765 23.0064 22.0312 22.6128C22.2974 22.2135 22.6851 21.901 23.1944 21.6753C23.7037 21.4497 24.32 21.3166 25.0433 21.276L28.4809 21.0677V22.2743L25.2256 22.4826C24.5138 22.5231 23.993 22.6707 23.6631 22.9253C23.3391 23.18 23.177 23.5388 23.177 24.0017V24.0191C23.177 24.4936 23.3564 24.864 23.7152 25.1302C24.074 25.3906 24.5254 25.5208 25.0694 25.5208C25.5844 25.5208 26.0416 25.4196 26.4409 25.217C26.8402 25.0087 27.1527 24.728 27.3784 24.375C27.6099 24.022 27.7256 23.6227 27.7256 23.1771V20.2604C27.7256 19.6817 27.5491 19.2419 27.1961 18.941C26.8489 18.6343 26.3252 18.4809 25.6249 18.4809C25.0636 18.4809 24.6035 18.5822 24.2447 18.7847C23.8859 18.9815 23.6458 19.2622 23.5243 19.6267L23.5156 19.6528H22.0052L22.0138 19.6007C22.0949 19.1088 22.2974 18.6806 22.6215 18.316C22.9513 17.9456 23.3767 17.6591 23.8975 17.4566C24.4183 17.2483 25.0115 17.1441 25.677 17.1441C26.4409 17.1441 27.0862 17.2685 27.6128 17.5174C28.1452 17.7662 28.5474 18.125 28.8194 18.5938C29.0972 19.0567 29.2361 19.6123 29.2361 20.2604V26.6667H27.7256V25.2865H27.5868C27.39 25.6163 27.1498 25.897 26.8663 26.1285C26.5885 26.36 26.2731 26.5365 25.9201 26.658C25.5671 26.7737 25.1793 26.8316 24.7569 26.8316Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5445_229154_clip_path",
    transform: "translate(4.44444 4.44444)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesText);
export default __webpack_public_path__ + "static/media/stories-text.9380610b257333e82ae3ac904b30674c.svg";
export { ForwardRef as ReactComponent };